import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import { Grid, Row, Col } from 'react-bootstrap';
import s from '../../content.scss';
import { wybierzGmine } from '../../../actions/gminy';
import PaperTile from '../../../components/PaperTile/PaperTile';
import PaperHeader from '../../../components/PaperHeader/PaperHeader';
import { notFoundImageURL } from '../../../config';
import godloPolski from './godlo-Polski.png';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage } from '../../../components/utils/utils';
import { replaceMultipleSpaces } from '../../../lib/utils';

import cmentarzLogo from './logo_cmentarz.png';
import ihubLogo from './logo_inspire.png';
import AdaMapLogo from './AdaMap.png';


class SzczegolyUrzedu extends React.Component {
  state = {
    showKonto: false,
    showInfo: false,
    filter_text: '',
    colors: 'normal',
    style: layoutColorStyle,
  }

  componentDidMount() {
    const colors = getThemeFromLocalStorage();
    let style = layoutColorStyle;
    if (colors !== 'normal') {
      style = headerStyle;
    }
    this.setState({ colors, style });
  }

  serviceFilterChange = (e) => {
    // zamiana kilku spacji na jedną
    const value = replaceMultipleSpaces(e.target.value);
    this.setState({ filter_text: value });
  };

  getValue = field => {
    if (this.props.districts) {
      if (this.props.prefix) {
		const district = this.props.districts[this.props.prefix];
		if (district) {
		  return (Object.keys(field).indexOf(field) > -1) ? district[field] : '';
		} else return '';
	  } else return '';
	} else return '';
  }

  renderIhubOrAdaMap = (urzad) => {
    let content =
      <a
        id="ihub-portal-link"
        href={`http://mapa.inspire-hub.pl/#/${this.props.districts[urzad].prefix}`}
        target='_blank'
        aria-label='Kliknij aby przejść do portalu Inspire-HUB'
        title='Kliknij aby przejść do portalu Inspire-HUB'
      >
        <img width={130} height={30} src={ihubLogo} alt="Logo portalu Inspire-HUB" />
      </a>;

    if (this.props.districts[urzad].AdaMapLink) {
      content =
        <a
          id="adamap-portal-link"
          href={this.props.districts[urzad].AdaMapLink}
          target='_blank'
          aria-label='Kliknij aby przejść do portalu AdaMap'
          title='Kliknij aby przejść do portalu AdaMap'
        >
          <img width={150} height={70} src={AdaMapLogo} alt="Logo portalu AdaMap" />
        </a>;
    }

    return content;
  }

  render() {
    let filteredServicesCount = 0;

    return (
      <div>
        {
          this.props.districts && Object.keys(this.props.districts).filter(
            urzad => urzad === this.props.prefix
          ).map(
            (urzad, index) => {
              let herbUrl = notFoundImageURL;
              const urzadData = this.props.districts[urzad];

              // Utworzenie linku do herbu
              if (urzadData && urzadData.herb) {
                herbUrl = `https://e-spdp.pl/oldihub/upload/herby/${urzadData.herb}`;
              }

              return (
                <div key={index}>
                  <PaperHeader title={this.props.districts[urzad].name} text="" />
                  <div className="paper-area" style={{ color: this.state.style[this.state.colors].color, backgroundColor: this.state.style[this.state.colors].backgroundColor }}>
                    <Grid className="poszerz">
                      <Row>
                        <Col className="centruj" sm={2} xs={6}>
                          <img className="herby" alt="Godło Polski" src={godloPolski} />
                        </Col>
                        <Col className="centruj" smHidden mdHidden lgHidden xs={6}>
                          <img className="herby" alt="Herb Urzędu" src={herbUrl} />

                        </Col>
                        <Col xs={12} smHidden mdHidden lgHidden className="info-button">
                          <div role="button" onClick={() => this.setState({ showInfo: !this.state.showInfo })}>
                            <span>{!this.state.showInfo ? 'Pokaż dane gminy' : 'Ukryj dane gminy'}</span>
                            <span className={`fa fa-chevron-${!this.state.showInfo ? 'down' : 'up'}`} aria-hidden="true" />
                          </div>
                        </Col>
                        <Col className="centruj" xs={12} sm={8}>
                          <div className={`paper-content-area ${!this.state.showInfo ? 'ukryj-info' : null}`}>
                            <Row className="eus-specs"><Col xs={4}>Miejsce załatwiania:</Col><Col xs={8}>{this.props.districts[urzad].placeOfSettling}</Col></Row>
                            <Row className="eus-specs"><Col xs={4}>Miejscowość:</Col><Col xs={8}>{this.props.districts[urzad].place}</Col></Row>
                            <Row className="eus-specs"><Col xs={4}>Adres:</Col><Col xs={8}>{this.props.districts[urzad].street.length !== 0 ? `${this.props.districts[urzad].street}` : this.props.districts[urzad].place}&nbsp;{this.props.districts[urzad].nrBuilding}{this.props.districts[urzad].nrLocal && this.props.districts[urzad].nrLocal.length !== 0 ? `/${this.props.districts[urzad].nrLocal}` : null}</Col></Row>
                            <Row className="eus-specs"><Col xs={4}></Col><Col xs={8}>{this.props.districts[urzad].zipCode}</Col></Row>
                            <Row className="eus-specs"><Col xs={4}>Telefon:</Col><Col xs={8}>{this.props.districts[urzad].phone}</Col></Row>
                            {this.props.districts[urzad].fax && <Row className="eus-specs"><Col xs={4}>Faks:</Col><Col xs={8}>{this.props.districts[urzad].fax}</Col></Row>}
                            <Row className="eus-specs"><Col xs={4}>Strona:</Col><Col xs={8}><a href={this.props.districts[urzad].pageWWW} target="_blank" rel="noopener noreferrer" style={{color: this.state.style[this.state.colors].color}}>{this.props.districts[urzad].pageWWW}</a></Col></Row>
                            <Row className="eus-specs"><Col xs={4}>Strona BIP:</Col><Col xs={8}><a href={this.props.districts[urzad].pageBIP} target="_blank" rel="noopener noreferrer" style={{color: this.state.style[this.state.colors].color}}>{this.props.districts[urzad].pageBIP}</a></Col></Row>
                            <Row className="eus-specs"><Col xs={4}>Adres e-mail:</Col><Col xs={8}><a href={`mailto:${this.props.districts[urzad].email}?subject=Dotyczy e-usług`} style={{color: this.state.style[this.state.colors].color}}>{this.props.districts[urzad].email}</a></Col></Row>
                            {this.props.districts[urzad].eDoreczeniaAddress && <Row className="eus-specs"><Col xs={4}>Adres do e-Doręczeń:</Col><Col xs={8}>{this.props.districts[urzad].eDoreczeniaAddress}</Col></Row>}
                            <Row className="eus-specs"><Col xs={4}>Godziny pracy urzędu:</Col><Col xs={8}>{this.props.districts[urzad].workingHours.map(
                              (item, i) => <div key={i}>{item}</div>,
                            )}</Col></Row>

                            <Row className="eus-specs">
                              <Col xs={4}>Numery rachunków bankowych:</Col>
                                <Col xs={8}>
                                  {this.props.districts[urzad].bankAccounts.map(
                                    (item, i) => <div className="eus-item" key={i}>{`- ${item.name}: ${item.number}`}</div>,
                                  )}
                                </Col>
                            </Row>
                            <Row className="eus-specs"><Col xs={12}><a id="szczegoly-urzedu-deklaracja" href={`/urzad/${this.props.districts[urzad].prefix}/deklaracja-dostepnosci`} style={{color: this.state.style[this.state.colors].color}}>Deklaracja dostępności</a></Col></Row>
                            {this.props.districts[urzad].questionnaireEnabled ?
                            <Row className="eus-specs">
                              <Col xs={4}>
                                <p style={{color: this.state.style[this.state.colors].color}}>
                                  Ankieta satysfakcji interesanta:
                                </p>
                              </Col>
                              <Col xs={8} style={{ paddingTop: '5px' }}>
                                <a
                                  id="szczegoly-urzedu-ankieta"
                                  className='btn btn-default button-wide'
                                  href={`/urzad/${this.props.districts[urzad].prefix}/ankieta-satysfakcji`}
                                  style={this.state.style[this.state.colors]}
                                >
                                  Pomagam i uzupełniam ankietę
                                </a>
                              </Col>
                            </Row> : null }

                            <Row className="eus-specs" style={{ textAlign: 'center' }}>
                              <Col xs={2} />
                              <Col xs={8}>
                                <h3>Portal mapowy</h3>
                              </Col>
                              <Col xs={2} />
                            </Row>
                            <Row className="eus-specs" style={{ textAlign: 'center' }}>
                              <Col xs={2} />
                              {this.props.districts[urzad].prefix === 'krosno' ?
                                <Col xs={8}>
                                  <a id="portal-link" href={`https://e-spdp.pl/${this.props.districts[urzad].prefix}`} target='_blank'>
                                    <img width={130} height={30} src={ihubLogo} alt="Logo IHUB" />
                                  </a>
                                </Col> :
                                <Col xs={8}>
                                  {this.renderIhubOrAdaMap(urzad)}
                                </Col>}
                              <Col xs={2} />
                            </Row>
                            {['gmina_siekierczyn', 'gmina_barciany'].includes(this.props.districts[urzad].prefix) ?
                            <div>
                            <Row className="eus-specs" style={{ textAlign: 'center' }}>
                              <Col xs={2} />
                              <Col xs={8}>
                                <h3>Portal cmentarzy</h3>
                              </Col>
                              <Col xs={2} />
                            </Row>
                            <Row className="eus-specs" style={{ textAlign: 'center' }}>
                              <Col xs={2} />
                              <Col xs={8}>
                                <a
                                  id="cmentarze-link"
                                  href={`https://e-spdp.pl/${this.props.districts[urzad].prefix}`}
                                  target='_blank'
                                >
                                  <img width={180} height={50} src={cmentarzLogo} alt="Logo eCmentarz" />
                                </a>
                              </Col>
                              <Col xs={2} />
                            </Row>
                            </div> : null}
                            {['gmina_gorzyca', 'gmina_slubice_powiat_slubicki'].includes(this.props.districts[urzad].prefix) ?
                            <Row className="eus-specs" style={{ textAlign: 'center' }}>
                              <Row className="eus-specs" style={{ textAlign: 'center' }}>
                                <Col xs={2} />
                                <Col xs={8}>
                                  <a id="cmentarze-portal-link" href={`https://e-spdp.pl/urzad/${this.props.districts[urzad].prefix}/cmentarze`} target='_blank'>
                                    CMENTARZE
                                  </a>
                                </Col>
                                <Col xs={2} />
                              </Row>
                            </Row>: null}
                          </div>
                        </Col>
                        <Col xsHidden sm={2}>
                          <img
                            className="herby"
                            alt="Herb Urzędu"
                            width="100"
                            src={herbUrl}
                          />
                        </Col>
                      </Row>
                      <Row>
                      </Row>
                    </Grid>
                  </div>
                  <PaperHeader title="E-usługi" text="" />
                  <Row>
                    <input
                      id="urzad_wyszukaj_usluge"
                      type="text"
                      className="form-control"
                      style={{ width: '60%', left: '20%', position: 'relative', margin: '25px 0px 15px 0px' }}
                      value={this.state.filter_text}
                      placeholder="Wyszukaj usługę..."
                      onChange={(e) => this.serviceFilterChange(e)}
                      aria-label="Wprowadź tekst aby wyszukać e-usługę"
                    />
                    {this.props.districts[urzad].services
                    .filter(service => this.props.eservices[service].isEnabled === true)
                    .map(
                      (item, i) => {
                        const customTitle = this.props.eservices[item].custom_titles && this.props.eservices[item].custom_titles[urzad] ? this.props.eservices[item].custom_titles[urzad] : this.props.eservices[item].title;
                        if (customTitle.toLowerCase().includes(this.state.filter_text.toLowerCase())) {
                          filteredServicesCount += 1;
                          const daneUrzedu = this.props.districts[urzad];
                          const cardUrl = `/euslugi/${item}?district=${this.props.districts[urzad].teryt}`;
                          return (
                            <Col
                              key={i}
                              md={12}
                            >
                              <PaperTile
                                href={`${cardUrl}`}
                                text={customTitle}
                                epuap={this.props.eservices[item].requiresEPUAP}
                                disabled={this.props.eservices[item].disabled}
                                wkLogin={daneUrzedu.wkLogin ? daneUrzedu.wkLogin : false}
                              />
                            </Col>
                          );
                        }
                      },
                    )}
                    {filteredServicesCount === 0 ?
                      <p style={{ width: '60%', left: '20%', position: 'relative', textAlign: 'center' }}>
                        Brak wyników wyszukiwania
                      </p>
                      : null}
                  </Row>
                </div>
              )
            },
          )
        }
      </div>
    );
  }
}
// export default withStyles(s)(SzczegolyUrzedu);

const mapState = (state) => ({
  wybranaGmina: state.gminy.wybranaGmina,
  districts: state.district.districts,
  eservices: state.district.eservices
});

const mapDispatch = {
  wybierzGmine,
};

export default withStyles(s)(connect(mapState, mapDispatch)(SzczegolyUrzedu));



// WEBPACK FOOTER //
// src/routes/urzad/szczegolyUrzedu/SzczegolyUrzedu.js